export default {
  namespaced: true,

  state: {
    data: {
      token: "",
      yellowBannerToProd: {},
      promoToProd: {},
    },
  },

  getters: {
    getToken: (state) => state.data.token,
    getYellowBannerToProd: (state) => state.data.yellowBannerToProd,
    getPromoToProd: (state) => state.data.promoToProd,
  },

  actions: {
    setToken({ commit }, payload) {
      commit("SET_TOKEN", payload);
    },
    setYellowBannerToProd({ commit }, payload) {
      commit("SET_BANNER_TO_PROD", payload);
    },
    setPromoToProd({ commit }, payload) {
      commit("SET_PROMO_TO_PROD", payload);
    },
  },

  mutations: {
    SET_TOKEN(state, data) {
      state.data.token = data;
    },
    SET_BANNER_TO_PROD(state, data) {
      state.data.yellowBannerToProd = data;
    },
    SET_PROMO_TO_PROD(state, data) {
      state.data.promoToProd = data;
    },
  },
};
